import { useCallback } from 'react';
import { formatLength, lengthRowText } from '../editor-model';
import { useFloorPlanPreferences } from './floorPlanPreferencesStore';

/** A length formatter bound to the preferred units: `formatLength` for hosts that show the editors' measurements. */
export function useLengthFormatter(): (lengthFeet: number) => string {
  const { units } = useFloorPlanPreferences();
  return useCallback((lengthFeet: number) => formatLength(lengthFeet, units), [units]);
}

/** A length row's text in the preferred units (`lengthRowText`): its sign kept, a dash where no length is set. */
export function useLengthText(): (lengthFeet: number | null) => string {
  const { units } = useFloorPlanPreferences();
  return useCallback((lengthFeet: number | null) => lengthRowText(lengthFeet, units), [units]);
}
